import {createAction, createAsyncAction} from 'typesafe-actions';



export const actionCreator = <T>(prefix: string, module: string, actionName: string) => {
  return createAction(`${prefix}/${module}/${actionName}`)<T>();
};

export const actionCreatorAsync = <T1, T2, T3>(
  prefix: string,
  module: string,
  actionName: string,
) => {
  return createAsyncAction(
    `${prefix}/${module}/${actionName}/REQUEST`,
    `${prefix}/${module}/${actionName}/SUCCESS`,
    `${prefix}/${module}/${actionName}/FAIL`,
  )<T1, T2, T3>();
};
